import React from 'react';
import { Router, Route, browserHistory } from 'dva/router';
import { LocaleProvider } from 'antd';
import ja_JP from 'antd/lib/locale-provider/ja_JP';
import AdPage from '../components/AdPage';

function RouterConfig(props) {
  return (
    <LocaleProvider locale={ja_JP}>
      <Router history={props.history}>
        <Route path="/" render={() => <AdPage app={props.app} appKey={props.app.appkey}/>} />
      </Router>
    </LocaleProvider>
  );
}

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/pages/ad/config/router.js